import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/arcsine';
import __var_2__ from '@stdlib/stats/base/dists/bernoulli';
import __var_3__ from '@stdlib/stats/base/dists/beta';
import __var_4__ from '@stdlib/stats/base/dists/betaprime';
import __var_5__ from '@stdlib/stats/base/dists/binomial';
import __var_6__ from '@stdlib/stats/base/dists/cauchy';
import __var_7__ from '@stdlib/stats/base/dists/chi';
import __var_8__ from '@stdlib/stats/base/dists/chisquare';
import __var_9__ from '@stdlib/stats/base/dists/cosine';
import __var_10__ from '@stdlib/stats/base/dists/degenerate';
import __var_11__ from '@stdlib/stats/base/dists/discrete-uniform';
import __var_12__ from '@stdlib/stats/base/dists/erlang';
import __var_13__ from '@stdlib/stats/base/dists/exponential';
import __var_14__ from '@stdlib/stats/base/dists/f';
import __var_15__ from '@stdlib/stats/base/dists/frechet';
import __var_16__ from '@stdlib/stats/base/dists/gamma';
import __var_17__ from '@stdlib/stats/base/dists/geometric';
import __var_18__ from '@stdlib/stats/base/dists/gumbel';
import __var_19__ from '@stdlib/stats/base/dists/hypergeometric';
import __var_20__ from '@stdlib/stats/base/dists/invgamma';
import __var_21__ from '@stdlib/stats/base/dists/kumaraswamy';
import __var_22__ from '@stdlib/stats/base/dists/laplace';
import __var_23__ from '@stdlib/stats/base/dists/levy';
import __var_24__ from '@stdlib/stats/base/dists/logistic';
import __var_25__ from '@stdlib/stats/base/dists/lognormal';
import __var_26__ from '@stdlib/stats/base/dists/negative-binomial';
import __var_27__ from '@stdlib/stats/base/dists/normal';
import __var_28__ from '@stdlib/stats/base/dists/pareto-type1';
import __var_29__ from '@stdlib/stats/base/dists/poisson';
import __var_30__ from '@stdlib/stats/base/dists/rayleigh';
import __var_31__ from '@stdlib/stats/base/dists/t';
import __var_32__ from '@stdlib/stats/base/dists/triangular';
import __var_33__ from '@stdlib/stats/base/dists/truncated-normal';
import __var_34__ from '@stdlib/stats/base/dists/uniform';
import __var_35__ from '@stdlib/stats/base/dists/weibull';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace dist
*/
var dist = {};

/**
* @name arcsine
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/arcsine}
*/
setReadOnly( dist, 'arcsine', __var_1__);

/**
* @name bernoulli
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/bernoulli}
*/
setReadOnly( dist, 'bernoulli', __var_2__);

/**
* @name beta
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/beta}
*/
setReadOnly( dist, 'beta', __var_3__);

/**
* @name betaprime
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/betaprime}
*/
setReadOnly( dist, 'betaprime', __var_4__);

/**
* @name binomial
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/binomial}
*/
setReadOnly( dist, 'binomial', __var_5__);

/**
* @name cauchy
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/cauchy}
*/
setReadOnly( dist, 'cauchy', __var_6__);

/**
* @name chi
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/chi}
*/
setReadOnly( dist, 'chi', __var_7__);

/**
* @name chisquare
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/chisquare}
*/
setReadOnly( dist, 'chisquare', __var_8__);

/**
* @name cosine
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/cosine}
*/
setReadOnly( dist, 'cosine', __var_9__);

/**
* @name degenerate
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/degenerate}
*/
setReadOnly( dist, 'degenerate', __var_10__);

/**
* @name discreteUniform
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/discrete-uniform}
*/
setReadOnly( dist, 'discreteUniform', __var_11__);

/**
* @name erlang
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/erlang}
*/
setReadOnly( dist, 'erlang', __var_12__);

/**
* @name exponential
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/exponential}
*/
setReadOnly( dist, 'exponential', __var_13__);

/**
* @name f
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/f}
*/
setReadOnly( dist, 'f', __var_14__);

/**
* @name frechet
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/frechet}
*/
setReadOnly( dist, 'frechet', __var_15__);

/**
* @name gamma
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/gamma}
*/
setReadOnly( dist, 'gamma', __var_16__);

/**
* @name geometric
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/geometric}
*/
setReadOnly( dist, 'geometric', __var_17__);

/**
* @name gumbel
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/gumbel}
*/
setReadOnly( dist, 'gumbel', __var_18__);

/**
* @name hypergeometric
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric}
*/

setReadOnly( dist, 'hypergeometric', __var_19__);

/**
* @name invgamma
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/invgamma}
*/
setReadOnly( dist, 'invgamma', __var_20__);

/**
* @name kumaraswamy
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy}
*/
setReadOnly( dist, 'kumaraswamy', __var_21__);

/**
* @name laplace
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/laplace}
*/
setReadOnly( dist, 'laplace', __var_22__);

/**
* @name levy
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/levy}
*/
setReadOnly( dist, 'levy', __var_23__);

/**
* @name logistic
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/logistic}
*/
setReadOnly( dist, 'logistic', __var_24__);

/**
* @name lognormal
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/lognormal}
*/
setReadOnly( dist, 'lognormal', __var_25__);

/**
* @name negativeBinomial
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial}
*/
setReadOnly( dist, 'negativeBinomial', __var_26__);

/**
* @name normal
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/normal}
*/
setReadOnly( dist, 'normal', __var_27__);

/**
* @name pareto1
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1}
*/
setReadOnly( dist, 'pareto1', __var_28__);

/**
* @name poisson
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/poisson}
*/
setReadOnly( dist, 'poisson', __var_29__);

/**
* @name rayleigh
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/rayleigh}
*/
setReadOnly( dist, 'rayleigh', __var_30__);

/**
* @name t
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/t}
*/
setReadOnly( dist, 't', __var_31__);

/**
* @name triangular
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/triangular}
*/
setReadOnly( dist, 'triangular', __var_32__);

/**
* @name truncatedNormal
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/truncated-normal}
*/
setReadOnly( dist, 'truncatedNormal', __var_33__);

/**
* @name uniform
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/uniform}
*/
setReadOnly( dist, 'uniform', __var_34__);

/**
* @name weibull
* @memberof dist
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats/base/dists/weibull}
*/
setReadOnly( dist, 'weibull', __var_35__);


// EXPORTS //
export default dist;

export { __var_1__ as arcsine, __var_2__ as bernoulli, __var_3__ as beta, __var_4__ as betaprime, __var_5__ as binomial, __var_6__ as cauchy, __var_7__ as chi, __var_8__ as chisquare, __var_9__ as cosine, __var_10__ as degenerate, __var_11__ as discreteUniform, __var_12__ as erlang, __var_13__ as exponential, __var_14__ as f, __var_15__ as frechet, __var_16__ as gamma, __var_17__ as geometric, __var_18__ as gumbel, __var_19__ as hypergeometric, __var_20__ as invgamma, __var_21__ as kumaraswamy, __var_22__ as laplace, __var_23__ as levy, __var_24__ as logistic, __var_25__ as lognormal, __var_26__ as negativeBinomial, __var_27__ as normal, __var_28__ as pareto1, __var_29__ as poisson, __var_30__ as rayleigh, __var_31__ as t, __var_32__ as triangular, __var_33__ as truncatedNormal, __var_34__ as uniform, __var_35__ as weibull};